module.exports = __webpack_public_path__ + "img/facebook-logo-5-1.0836892b.png";